import { axiosGet } from '@/api/handlers';
import { PaymentGroupUploaderTemplate } from '../projects/_models/payment-uploader';

export const fetchPaymentGroupUploaderTemplate = async (projectId: string) => {
  const templateData = await axiosGet(
    `/api/projects/${projectId}/payment-groups/template-csv-upload/`,
  );
  return PaymentGroupUploaderTemplate.parse(templateData);
};
